import React, { useState } from "react";
import { usePageHeader } from "../../MasterPage/MasterPage";
import {
  Typography,
  CircularProgress,
  Paper,
  Button,
  TextField
} from "@mui/material";
import { styled } from "@mui/material/styles";
import { readHTML } from "./MyGenAssist"; // Import the function

const cardWidth = 275;

const Item = styled(Paper)(({ theme }) => ({
  minWidth: cardWidth,
  backgroundColor: theme.palette.mode === "dark" ? "#1A2027" : "#fff",
  ...theme.typography.body2,
  padding: theme.spacing(1),
  textAlign: "left",
  color: theme.palette.text.secondary,
}));

export default function SocailMedia() {
  usePageHeader("Mídias Sociais");
  const [input, setInput] = useState("");
  const [apiResponse, setApiResponse] = useState('');
  const [loading, setLoading] = useState(false);

  const handleInputSubmit = async (input) => {
    setLoading(true);
    try {
      const token = process.env.REACT_APP_MGA_ASSISTANT_TOKEN;
      const assistantId = process.env.REACT_APP_MGA_ASSISTANT_ID;
      
      const response = await readHTML( token, assistantId, input); // Call the function
      setApiResponse(response);
    } catch (error) {
      console.error('Error fetching data:', error);
      setApiResponse('Error fetching data');
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <div style={{ width: "100%", paddingRight: "50px" }}>
        <h5 className="social-media-heading" style={{ color: "var(--bayer-md-blue)", fontWeight: "bold" }}>
          Acompanhe os últimos 15 dias nas mídias sociais
        </h5>
        <Typography>
          Acompanhe as últimas postagens nas mídias sociais, utilize a barra de pesquisa
          para busca de palavras-chaves ou pessoas nas redes sociais
        </Typography>
        <form
          className="gap-2 mt-3 mb-2"
          onSubmit={(e) => {
            e.preventDefault();
            handleInputSubmit(input);
          }}
          style={{ display: 'flex', flexDirection: 'column' }}
        >
          <TextField
            label="Pesquisar"
            variant="outlined"
            size="small"
            style={{ width: "100%", marginBottom: "10px" }}
            value={input}
            onChange={(e) => setInput(e.target.value)}
          />
          <Button
            variant="contained"
            style={{ width: "150px" }}
            type="submit"
          >
            Enviar
          </Button>
        </form>
        {loading && <CircularProgress />} {/* Display loading indicator */}
        
        {/* Display the API response */}
        <div dangerouslySetInnerHTML={{ __html: apiResponse }} style={{ marginTop: "20px" }} />
      </div>
    </>
  );
}
